function processToken(token, loginTech, devPort, setUserName) {
  const fetch_cmd = devPort + loginTech + token;
  console.log("Logging in...");
  console.log(fetch_cmd)
  fetch(fetch_cmd, {
    credentials: "include",
    mode: "cors",
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log(data);
      if (data) {
        setUserName(data);
        //navigate("/selectmembership");
      } else {
        console.log("Invalid UserId");
      }
    });
}

export default processToken;
